export default __webpack_public_path__ + "f8263bdb2bfc94d24d0377ef22f3dc8d.png";